import { useOfficialStore } from '$/store/useOfficialStore';

const BACK_URL = {
  // development: process.env.NEXT_PUBLIC_REBONEO_SERVER_URL?.includes('localhost') ? 'https://ai-engine-gateway-pre-roboneo.meitu.com' : `${process.env.NEXT_PUBLIC_REBONEO_SERVER_URL}/ai-engine-gateway`,
  development: 'https://ai-engine-gateway-pre-roboneo.meitu.com',
  dev: 'https://ai-engine-gateway-develop-pre-roboneo.meitu.com',
  pre: 'https://ai-engine-gateway-pre-roboneo.meitu.com',
  beta: 'https://ai-engine-gateway-beta-roboneo.meitu.com',
  release: 'https://ai-engine-gateway-roboneo.meitu.com',
};
// 内网地址
const INTERNAL_BACK_URL = {
  development: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  dev: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  pre: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  beta: 'https://ai-engine-gateway-beta-roboneo-cloud.meitu-int.com',
  release: 'https://ai-engine-gateway-roboneo-cloud.meitu-int.com',
};
const OVERSEA_BACK_URL = {
  development: 'https://ai-engine-gateway-pre-roboai.starii.com',
  dev: 'https://ai-engine-gateway-pre-roboai.starii.com',
  pre: 'https://ai-engine-gateway-pre-roboai.starii.com',
  beta: 'https://ai-engine-gateway-beta-roboai.starii.com',
  release: 'https://ai-engine-gateway-roboai.starii.com',
};
const CANVAS_URL = {
  development: '//prewebapi.roboneo.com',
  dev: '//prewebapi.roboneo.com',
  pre: '//prewebapi.roboneo.com',
  beta: '//betawebapi.roboneo.com',
  release: '//webapi.roboneo.com',
};
const OVERSEA_CANVAS_URL = {
  development: '//prewebapi-roboai.starii.com',
  dev: '//prewebapi-roboai.starii.com',
  pre: '//prewebapi-roboai.starii.com',
  beta: '//betawebapi-roboai.starii.com',
  release: '//webapi-roboai.starii.com',
};
const APP = {
  roboneo: {
    token: () => {
      const { token } = useOfficialStore.getState();
      return token;
    },
    baseURL: () => {
      const { env, isOverseaServer = false } = useOfficialStore.getState();
      return isOverseaServer ? OVERSEA_BACK_URL[env] : BACK_URL[env];
    },
    baseInternalURL: () => {
      const { env } = useOfficialStore.getState();
      return INTERNAL_BACK_URL[env];
    },
    /** SSR 显式传入海外标记，避免依赖尚未初始化的客户端 store。 */
    baseCanvasURL: (isOverseaServer = false) => {
      const env = process.env.NEXT_PUBLIC_ENVIRONMENT || 'release';
      const canvasUrlMap = isOverseaServer ? OVERSEA_CANVAS_URL : CANVAS_URL;
      return canvasUrlMap[env as keyof typeof canvasUrlMap];
    },
    api: {
      // 首页案例分类
      overseaFeatures: '/official/feature.json',
      activityList: '/activity/list.json',
      // Ai 工具-任务提交
      aiToolSubmit: '/ai_tool/submit.json',
      aiToolQuery: '/ai_tool/query.json',
      aiToolList: '/ai_tool/list.json',
      aiToolPromptStream: '/ai_tool/ai_prompt_stream.json',
      fontList: '/font/list.json',

      // 视频编辑器 WebAPI（/video_editor）
      videoEditorExportCancel: '/video_editor/export/cancel.json',
      videoEditorExportCreate: '/video_editor/export/create.json',
      videoEditorExportList: '/video_editor/export/list.json',
      videoEditorExportQuery: '/video_editor/export/query.json',
      videoEditorMaterialCategory: '/video_editor/material/category.json',
      videoEditorMaterialCategoryMaterials: '/video_editor/material/category_materials.json',
      videoEditorMaterialCreate: '/video_editor/material/create.json',
      videoEditorMaterialDelete: '/video_editor/material/delete.json',
      videoEditorMaterialList: '/video_editor/material/list.json',
      videoEditorMaterialRename: '/video_editor/material/rename.json',
      videoEditorMediaVideoTranscode: '/video_editor/media/video_transcode.json',
      videoEditorMediaVideoTranscodeQuery: '/video_editor/media/video_transcode_query.json',
      videoEditorProjectCreate: '/video_editor/project/create.json',
      videoEditorProjectDelete: '/video_editor/project/delete.json',
      videoEditorProjectDetail: '/video_editor/project/detail.json',
      videoEditorProjectHistory: '/video_editor/project/history.json',
      videoEditorProjectInfo: '/video_editor/project/info.json',
      videoEditorProjectList: '/video_editor/project/list.json',
      videoEditorProjectRename: '/video_editor/project/rename.json',
      videoEditorProjectSave: '/video_editor/project/save.json',
      videoEditorProjectSummary: '/video_editor/project/summary.json',
    },
  },
};

export default APP;
